import React from 'react';
import { motion } from 'framer-motion';
const pressBadges = [{
  name: 'Y Combinator',
  logo: 'https://cdn.magicpatterns.com/uploads/gYArx9LnCL1zUGZHPNRF8U/Y_Combinator_logo_text_wordmark.png',
  label: 'Backed by'
}, {
  name: 'TechCrunch',
  logo: 'https://cdn.magicpatterns.com/uploads/3bCBHE6nPmewusss3BgLVF/techcrunch-logo.png.webp',
  label: null
}, {
  name: 'Forbes',
  logo: 'https://cdn.magicpatterns.com/uploads/9arX29ehiKEbnF8gb5xKPQ/Forbes_logo.svg.png',
  label: 'Featured by'
}];
export function TrustBar() {
  const tickerItems = [...pressBadges, ...pressBadges, ...pressBadges, ...pressBadges];
  return <div className="w-full bg-white py-6 overflow-hidden relative" data-id="element-6285">
      {/* Fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-6286" />
      <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-6287" />

      <div className="flex w-max animate-ticker" data-id="element-6288">
        {tickerItems.map((badge, index) => <div key={index} className="flex items-center gap-2.5 px-12" data-id="element-6289">
            {badge.label && <span className="text-xs text-slate-400 font-medium whitespace-nowrap" data-id="element-6290">
                {badge.label}
              </span>}
            <img src={badge.logo} alt={`${badge.name} logo`} className="h-6 max-w-[140px] object-contain" data-id="element-6291" />
          </div>)}
      </div>
    </div>;
}